import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LocalStorageHelper } from '../../helper/LocalStorageHelper';
import { RootState } from '../store';
import { AiHistoryModel } from '@Helper/Interfaces';

type aiHistoryProps = {
  aiHistory: AiHistoryModel[];
  selectedAiHistory?: AiHistoryModel;
  isShowAiHistoryModal: boolean;
};
const localStorage = new LocalStorageHelper();

const initialState: aiHistoryProps = {
  aiHistory: localStorage.getAiHistoryTray(),
  isShowAiHistoryModal: false,
};

export const aIHistorySlice = createSlice({
  name: 'aiHistory',
  initialState,
  reducers: {
    postAiHistory: (state, action: PayloadAction<AiHistoryModel>) => {
      if (state.aiHistory === null) {
        state.aiHistory = [];
      }
      state.aiHistory.push(action.payload);
      localStorage.setAiHistoryTray([...state.aiHistory]);
    },
    deleteAiHistory: (state, action: PayloadAction<string>) => {
      state.aiHistory = state.aiHistory.filter(
        (item: AiHistoryModel) => item.conversationId !== action.payload
      );
      localStorage.setAiHistoryTray(state.aiHistory);
    },
    selectedAiHistoryUpdate: (
      state,
      action: PayloadAction<{
        selectedAiHistory?: AiHistoryModel;
        isShowAiHistoryModal: boolean;
      }>
    ) => {
      state.selectedAiHistory = action.payload.selectedAiHistory;
      state.isShowAiHistoryModal = action.payload.isShowAiHistoryModal;
    },
    postAiHistoryTray: (state, action: PayloadAction<AiHistoryModel[]>) => {
      state.aiHistory = action.payload;
    },
  },
});

export const {
  postAiHistory,
  deleteAiHistory,
  selectedAiHistoryUpdate,
  postAiHistoryTray,
} = aIHistorySlice.actions;

export const getAiHistory = (state: RootState) => state.aIHistoryReducer;

export default aIHistorySlice.reducer;
